import { createApiEffect } from '@/features/api/common/create-api-effect'
import { FolderType } from '@/features/api/assignment/types/types'

export const getExamTestFolderFx = createApiEffect<number, FolderType>({
  requestMapper: (id) => ({
    method: 'GET',
    url: `/api/exams-app/folders/${id}/`,
  }),
})
